import { SVGProps } from "react";
const SavedPostSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      stroke="#2A2D31"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.536 3h8.929c.986 0 1.786.806 1.786 1.8V21l-6.242-3.273L5.75 21V4.8c0-.994.8-1.8 1.786-1.8Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SavedPostSvg;
